import React from 'react';

import AssignmentsFoldersDropdown from '../AssignmentsFoldersDropdown.react';
import {Icon, NavItem} from '@albert-io/atomic';
import {Link} from 'react-router';
import {usePathname} from 'lib/router/usePathname';
import useNavItems from '../useNavItems';

const MainNavItems = () => {
  // Subscribed pathname (not window.location): this component is prop-less and compiled,
  // so it only re-renders when a subscribed input changes — the router subscription is
  // what moves the active-link highlight on navigation.
  const pathname = usePathname();
  const {getIsMatchingRoute, mainNavItems} = useNavItems();

  return (
    <nav className='global-nav__main' aria-label='main'>
      <ul className='global-nav__main-list'>
        {mainNavItems.map((navItem) => {
          const {hardLink = false, icon, key, name, route} = navItem;

          const isMatchingRoute = getIsMatchingRoute(navItem);
          const props = {
            [hardLink ? 'href' : 'to']: route
          };
          const LinkElement = hardLink ? 'a' : Link;

          if (key === 'assignments') {
            return (
              // @ts-ignore
              <AssignmentsFoldersDropdown
                key={key}
                isMatchingRoute={isMatchingRoute}
                navItem={navItem}
                pathname={pathname}
                {...props}
              />
            );
          }

          return (
            <li key={key}>
              {/* @ts-ignore */}
              <NavItem {...props} as={LinkElement} active={isMatchingRoute} className='gap-x1 flex'>
                {icon !== undefined && <Icon icon={icon} />}
                {name}
              </NavItem>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MainNavItems;
